import axios from "axios";

const client = axios.create({
  baseURL: "https://ws.u-stc.net:8821",
  //   baseURL: "http://10.10.10.26:9001", // 개발
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

/**
 * @param {platform_main_ids}  플랫폼 메인 ID
 * @returns 플랫폼 상세 정보
 */
const getIsDirectForPaltform = async (platform_main_ids) => {
  platform_main_ids = Array.isArray(platform_main_ids)
    ? platform_main_ids
    : [platform_main_ids];

  let platformDetails = [];

  try {
    platformDetails = await Promise.all(
      platform_main_ids.map((platform_main_id) =>
        client
          .post(`/platformitem/select`, { platform_main_id })
          .then((res) => ({
            platform_main_id: platform_main_id,
            is_direct: res?.data?.data?.is_direct,
          })),
      ),
    );
  } catch (e) {
    console.warn("useCart getIsDirectForPaltform error", e);
  } finally {
    return platformDetails;
  }
};

const removeEmptyValues = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
    if(typeof obj[key] === 'string' && obj[key].trim() === '') {
      delete obj[key];
    }
    if (Array.isArray(obj[key]) && obj[key].length === 0) {
      delete obj[key];
    }
  })
};

export { getIsDirectForPaltform as getPaltformDetails, removeEmptyValues };
export default client;
